import React, { Component } from 'react';
import JournalExplanationConceptsView from './JournalExplanationConceptsView';
import { connect } from 'react-redux';
import * as journalActions from 'actions/journalActions';
import { selectFields } from './StepFields/GeneralConcepts';

class ExplanacionConcepts extends Component {
  constructor(props) {
    super(props);
    this.state = { localStep: 1 };
  }

  changeStep = step => {
    if (1 <= step && step <= 6) {
      this.setState({ localStep: step });
    } else {
      const {
        updateJournalRequest,
        journal,
        match: { params },
      } = this.props;

      updateJournalRequest({
        first_introduction_completed: true,
        id: params.id,
      });
    }
  };

  render() {
    const stepFields = selectFields(this.state.localStep);

    return (
      <JournalExplanationConceptsView
        {...this.props}
        changeStep={this.changeStep}
        state={this.state}
        stepFields={stepFields}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    journal: state.journalReducer.journal,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateJournalRequest: journal => dispatch(journalActions.updateJournalRequest(journal)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExplanacionConcepts);
